module.exports = __webpack_public_path__ + "31bd4bd1b3d93f4165a76b6984992770.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img3.jpg
// module id = 542
// module chunks = 0